import cx from "classnames";
import { useState } from "react";

import { Icon } from "common/ui/Icon";

import styles from "./Sidebar.module.scss";

interface SidebarProps {
  children: React.ReactNode;
  className?: string;
}

export function Sidebar({ children, className }: SidebarProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <aside className={cx(styles.Sidebar, className, { [styles.isOpen]: isOpen })}>
        <button
          className={styles.CloseButton}
          onClick={() => setIsOpen(false)}
        >
          <Icon icon="closeMajor" />
        </button>
        {children}
      </aside>
      <button
        className={styles.VisibilityButton}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Icon icon="moreVertical" />
      </button>
    </>
  );
};
